import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import ScheduleRaw from '../tabs/registry/views/Schedule'
import { withRouter } from '@/app/navigation/withRouter'

const Schedule = withRouter(ScheduleRaw)

export const DriverSchedulePage = ({ match }) => {
  const { params } = match
  const { companyId, driverId, year } = params

  return (
    <div  style={{ position: 'relative', width: '100%', height: '100%' }}>
      <Routes>
        <Route
          path="*"
          element={
            <Schedule
              companyId={companyId}
              driverId={driverId}
              year={parseInt(year, 10)}
            />
          }
        />
      </Routes>
    </div>
  )
}


